import 'bulma/css/bulma.css'

import Vue from 'vue'
import App from './App'

// configs
import { router } from './config/router'
import './config/axios'
import './config/auth'
import './config/utils'

// plugins
import Vuelidate from 'vuelidate'
import moment from 'moment'
import 'moment/locale/fr'
import VueMoment from 'vue-moment'

window.Promise = require('bluebird')

Vue.use(Vuelidate)
Vue.use(VueMoment, { moment })

Vue.config.productionTip = false

// global mixins
Vue.mixin({
  computed: {
    user() {
      return this.$auth.user()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  created() {
    window.Promise.onPossiblyUnhandledRejection(this.$handleErrors)
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js